import { HttpClient } from '../../../httpClient'
import { OpalApiRequestParams } from '../../../schema'

interface DeleteViewArguments {
  params: OpalApiRequestParams<'DeleteViewV3'>
}

export async function deleteView({
  params,
}: DeleteViewArguments): Promise<null> {
  const url = new URL(
    `/loupe/v3/views/${params.path.view_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then(() => null)
}
